module.exports = __webpack_public_path__ + "img/cooperation_unit_19.e878b281.jpg";